/**
 * 获取界面的搜索项
 * @param {*} active 具体界面
 */
export function getSearchData(active) {
    let data = []
    switch (active) {
        case "addreddBook":
            // 通讯录
            data = [{
                    title: "姓名",
                    type: "input",
                    value: "",
                    key: "name",
                }, {
                    title: "入伍年份",
                    type: "time-year",
                    value: "",
                    key: "armyDate",
                },
                {
                    title: "职业技能等级",
                    type: "select",
                    value: "",
                    key: "leverl",
                    options: []
                },
                {
                    title: "上岗/复岗考核",
                    type: "select",
                    value: "",
                    key: "examFlag",
                    options: []
                },
            ]
            break;
        case "paper":
            // 试卷
            data = [{
                    title: "名称",
                    type: "input",
                    value: "",
                    key: "name"
                },
                {
                    title: "科目",
                    type: "select",
                    value: "",
                    key: "subject",
                    options: []
                },
            ]
            break;
        case "exam":
            // 考试管理
            data = [{
                    title: "主题",
                    type: "input",
                    value: "",
                    key: "name"
                },
                {
                    title: "考试时间",
                    type: "time-range",
                    value: [],
                    key: "time"
                },
            ]
            break
        case "read":
            // 阅卷
            data = [{
                    title: "主题",
                    type: "input",
                    value: "",
                    key: "name"
                },
                {
                    title: "考试时间",
                    type: "time-range",
                    value: [],
                    key: "time"
                },
            ]
            break;
        case "subject":
            // 科目
            data = [{
                title: "科目名称",
                type: "input",
                value: "",
                key: "name",
            }, ]
            break
        case "workLicense":
            // 上岗证考核
            data = [{
                    title: "任务主题",
                    type: "input",
                    value: "",
                    key: "name",
                },
                {
                    title: "专业",
                    type: "select",
                    value: "",
                    key: "professional",
                    options: []
                },
            ]
            break
        case "workLicenseRecord":
            // 所有上岗证
            data = [{
                    title: "学员",
                    type: "select",
                    value: "",
                    key: "uId",
                    options: []
                },
                {
                    title: "专业",
                    type: "select",
                    value: "",
                    key: "professional",
                    options: []
                },
                {
                    title: "工种",
                    type: "select",
                    value: "",
                    key: "station",
                    options: []
                },
            ]
            break
        case "occupation":
            // 职业技能等级考核任务列表
            data = [{
                    title: "任务主题",
                    type: "input",
                    value: "",
                    key: "name",
                },
                {
                    title: "专业",
                    type: "select",
                    value: "",
                    key: "professional",
                    options: []
                },
            ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取界面搜索框旁边的按钮
 * @param {*} active 具体界面
 */
export function getTopButArray(active) {
    let data = []
    switch (active) {
        case "addreddBook":
            // 通讯录
            data = [
                { name: "新增用户", active: "create", icon: "el-icon-plus" },
                { name: "通讯录导入", active: "import", icon: "el-icon-upload" },
                { name: "通讯录导出", active: "export", icon: "el-icon-download" },
            ]
            break;
        case "paper":
            // 试卷列表
            data = [
                { name: "新增试卷", active: "create", icon: "el-icon-plus" },
                // { name: "试卷导入", active: "import", icon: "el-icon-upload" },
            ]
            break;
        case "exam":
            // 考试管理
            data = [
                { name: "新增考试", active: "create", icon: "el-icon-plus" },
                { name: "考试导出", active: "export_exam", icon: "el-icon-upload" },
            ]
            break;
        case "read_student":
            // 待阅卷学生列表
            data = [
                { name: "成绩导入", active: "import", icon: "el-icon-upload" },
            ]
            break;
        case "subject":
            // 科目列表
            data = [
                { name: "新增科目", active: "create", icon: "el-icon-plus" },
            ]
            break;
        case "workLicense":
            // 上岗证考核
            data = [
                { name: "新增考核", active: "create", icon: "el-icon-plus" },
            ]
            break
        case "workLicenseUser":
            // 查看当前上岗证的所有用户
            data = [
                { name: "上岗证生成", active: "workLicense", icon: "el-icon-postcard" },
                { name: "考核归档", active: "end", icon: "el-icon-wallet" },
                { name: "实操成绩导入", active: "import", icon: "el-icon-download" },
                { name: "数据统计", active: "echart", icon: "el-icon-bangzhu" },
            ]
            break
        case "workLicenseUserOverEchart":
            // 查看当前上岗证的所有用户(已归档)
            data = [
                { name: "数据统计", active: "echart", icon: "el-icon-bangzhu" },
            ]
            break
        case "workLicenseManageUserList":
            // 上岗证管理
            data = [
                { name: "上岗证导入", active: "import", icon: "el-icon-bangzhu" },
                { name: "上岗证导出", active: "export", icon: "el-icon-bangzhu" },
            ]
            break
        case "occupation":
            // 职业技能等级考核任务列表
            data = [
                { name: "新增考核", active: "create", icon: "el-icon-plus" },
            ]
            break;
        case "occupationeUser":
            // 查看当前职业技能等级的所有用户
            data = [
                { name: "考核归档", active: "end", icon: "el-icon-wallet" },
                { name: "实操成绩导入", active: "import", icon: "el-icon-download" },
            ]
            break
        case "occupationeUserOverEchart":
            // 查看当前职业技能等级的所有用户(已归档)
            data = [
                { name: "数据统计", active: "echart", icon: "el-icon-bangzhu" },
            ]
            break

        default:
            break;
    }
    return data
}

/**
 * 获取表格表头数据
 * @param {*} active 具体界面
 */
export function getTableMenuData(active) {
    let data = []
    switch (active) {
        case "addreddBook":
            // 通讯录
            data = [
                { name: "姓名", key: "name", isStar: false, isColor: true, hasTip: true },
                { name: "身份证", key: "identityCard", isStar: false },
                { name: "职业技能等级", key: "leverl", isStar: false },
                { name: "入伍日期", key: "armyDate", isStar: true },
                { name: "出生日期", key: "birthday", isStar: true },
                { name: "学历", key: "education", isStar: false },
                { name: "初次到岗时间", key: "firstCome", isStar: false },
                { name: "登录账号", key: "account", isStar: false },
            ]
            break;
        case "department":
            // 部门设置
            data = [
                { name: "姓名", key: "name", width: "", isTip: true },
                { name: "职业技能等级", key: "leverl", width: "", isTip: false },
                { name: "身份证", key: "identityCard", width: "", isTip: false },
                { name: "账号", key: "account", width: "", isTip: false },
            ]
            break
        case "profession":
            // 专业设置
            data = [
                { name: "姓名", key: "name", width: "", isTip: true },
                { name: "职业技能等级", key: "leverl", width: "", isTip: false },
                { name: "身份证", key: "identityCard", width: "", isTip: false },
                { name: "账号", key: "account", width: "", isTip: false },
            ]
            break
        case "paper":
            // 试卷
            data = [
                { name: "试卷名称", key: "name", isStar: false },
                { name: "创建者", key: "createUer", isStar: false },
                { name: "相关科目", key: "subject", isStar: false },
            ]
            break
        case "exam":
            // 考试管理
            data = [
                { name: "考试主题", key: "name", isStar: false },
                { name: "考试时间", key: "time", isStar: false },
                { name: "状态", key: "status", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "试卷", key: "testParperName", isStar: false },
                { name: "考试部门", key: "department", isStar: false },
                { name: "参考人数", key: "personNum", isStar: false },
                { name: "阅卷老师", key: "readOver", isStar: false },
                // { name: "关联任务", key: "associatedTask", isStar: false, isPrimary: true },
            ]
            break
        case "examPersonDetails":
            // 查看本场考试学员分布情况
            data = [
                { name: "姓名", key: "userName" },
                { name: "部门", key: "department" },
                { name: "考场号", key: "examRoom" },
                { name: "座位号", key: "seat" },
                { name: "成绩(分)", key: "grade" },
                { name: "正确题数", key: "successNum" },
                { name: "错误题数", key: "errorNum" },
                { name: "交卷时间", key: "subTime" },
                { name: "状态", key: "status" },
                // { name: "关联任务", key: "associatedTask", isStar: false, isPrimary: true },
            ]
            break
        case "workLicense":
            // 上岗证考核任务
            data = [
                { name: "考核主题", key: "name", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "工种/岗位", key: "station", isStar: false },
                { name: "理论考试主题", key: "exam", isStar: false },
                { name: "考核状态", key: "status", isStar: false },
                { name: "理论占比", key: "examGrade", isStar: false },
                { name: "实操占比", key: "practicalGrade", isStar: false },
            ]
            break;
        case "workLicenseUser":
            // 查看当前上岗证的所有用户
            data = [
                { name: "学员姓名", key: "userName", isStar: false },
                { name: "理论成绩", key: "examGrade", isStar: false },
                { name: "实操成绩", key: "practicalGrade", isStar: false },
                { name: "总成绩", key: "grade", isStar: false },
                { name: "是否合格", key: "isPass", isStar: false, isColor: true },
            ]
            break
        case "workLicenseRecord":
            // 所有上岗证
            data = [
                { name: "学员姓名", key: "userName", isStar: false },
                { name: "上岗证编号", key: "number", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "工种/岗位", key: "station", isStar: false },
                { name: "发证日期", key: "time", isStar: false },
                { name: "剩余分数", key: "surplusGrade", isStar: false },
                { name: "状态", key: "status", isStar: false },
            ]
            break
        case "workLicenseManageUserList":
            // 上岗证管理
            data = [
                { name: "学员姓名", key: "userName", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "上岗证编号", key: "number", isStar: false },
                { name: "工种/岗位", key: "station", isStar: false },
                { name: "发证日期", key: "time", isStar: false },
                { name: "剩余分数", key: "surplusGrade", isStar: false },
                { name: "上岗证状态", key: "status", isStar: false, isColor: true },
            ]
            break
        case "occupation":
            // 职业技能等级考核任务
            data = [
                { name: "考核主题", key: "name", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "当前考核等级", key: "station", isStar: false },
                { name: "理论考试主题", key: "exam", isStar: false },
                { name: "考核状态", key: "status", isStar: false },
                { name: "理论占比", key: "examGrade", isStar: false },
                { name: "实操占比", key: "practicalGrade", isStar: false },
            ]
            break;
        case "occupationeUser":
            // 查看当前职业技能等级的所有用户
            data = [
                { name: "学员姓名", key: "userName", isStar: false },
                { name: "理论成绩", key: "examGrade", isStar: false },
                { name: "实操成绩", key: "practicalGrade", isStar: false },
                { name: "总成绩", key: "grade", isStar: false },
                { name: "是否合格", key: "isPass", isStar: false, isColor: true },
            ]
            break

        default:
            break;
    }
    return data
}

/**
 * 获取表格按钮数据
 * @param {*} active 具体界面 
 * @param {*} status 当前数据状态
 */
export function getTableButtonList(active, status) {
    let data = []
    switch (active) {
        case "addreddBook":
            // 通讯录
            switch (status) {
                case "normal":
                    // 正常通讯录按钮
                    data = [
                        { text: "编辑", active: "edit_user" },
                        { text: "冻结", active: "freeze_user" },
                        { text: "删除", active: "delete_user" },
                        { text: "密码重置", active: "reset_psw" },
                    ]
                    break;
                case "freeze":
                    // 已冻结通讯录按钮
                    data = [
                        { text: "解冻", active: "unfreeze_user" },
                        { text: "删除", active: "delete_user" },
                    ]
                    break;

                default:
                    break;
            }
            break;
        case "paper":
            // 试卷
            data = [
                { text: "预览", active: "preview" },
                { text: "编辑", active: "edit_paper" },
                { text: "删除", active: "delete_paper" },
            ]
            break;
        case "exam":
            // 考试管理
            switch (status) {
                case "待发布":
                    data = [
                        { text: "发布", active: "issue_exam" },
                        // { text: "启用B卷", active: "start_plan_b" },
                        { text: "编辑", active: "edit_exam" },
                        { text: "删除", active: "delete_exam" },
                        { text: "操作记录", active: "operat" },
                        { text: "考试计划", active: "export_exam_plane" },
                    ]
                    break;
                case "已发布":
                    data = [
                        { text: "查看详情", active: "show_exam" },
                        { text: "结束考试", active: "start_read" },
                        { text: "取消发布", active: "unissue_exam" },
                        { text: "考试计划", active: "export_exam_plane" },
                        { text: "考试归档", active: "end_exam" },
                        { text: "操作记录", active: "operat" },
                    ]
                    break
                case "待阅卷":
                    data = [
                        { text: "查看详情", active: "show_exam" },
                        { text: "考试归档", active: "end_exam" },
                        { text: "操作记录", active: "operat" },
                        { text: "导出成绩", active: "import" },
                    ]
                    break
                case "已归档":
                    data = [
                        { text: "查看详情", active: "show_exam" },
                        { text: "操作记录", active: "operat" },
                        { text: "导出成绩", active: "import" },
                    ]
                    break

                default:
                    break;
            }
            break
        case "workLicense":
            // 上岗证考核
            switch (status) {
                case "未发布":
                    data = [
                        { text: "发布", active: "issue" },
                        { text: "查看", active: "show" },
                        { text: "编辑", active: "edit" },
                        { text: "删除", active: "delete" },
                    ]
                    break;
                case "已发布":
                    data = [
                        { text: "查看", active: "show" },
                        { text: "取消发布", active: "unissue" },
                        { text: "归档", active: "end" },
                    ]
                    break;
                case "已归档":
                    data = [
                        { text: "查看", active: "show" },
                    ]
                    break;

                default:
                    break;
            }
            break
        case "workLicenseUser":
            // 查看当前上岗证的所有用户
            switch (status) {
                case "合格":
                    data = [
                        { text: "上岗证生成", active: "workLicense" },
                    ]
                    break;
                case "不合格":
                    data = [
                        { text: "实操成绩录入", active: "entering" }
                    ]
                    break
                case "已发":
                    data = [
                        { text: "查看上岗证", active: "show" }
                    ]

                default:
                    break;
            }
            break
        case "workLicenseRecord":
            // 所有上岗证
            switch (status) {
                case "正常":
                    data = [
                        { text: "查看", active: "show" },
                        { text: "扣分记录", active: "record" },
                    ]
                    break;
                case "作废":
                    data = [
                        { text: "查看", active: "show" },
                        { text: "扣分记录", active: "record" },
                    ]
                    break

                default:
                    break;
            }
            break
        case "workLicenseManageUserList":
            // 上岗证管理
            switch (status) {
                case "正常":
                    data = [
                        { text: "查看", active: "show" },
                        { text: "编辑", active: "edit" },
                        { text: "作废", active: "cancel" },
                        { text: "扣分", active: "deduct" },
                        { text: "扣分记录", active: "record" },
                        { text: "删除", active: "delete" },
                    ]
                    break;
                case "作废":
                    data = [
                        { text: "扣分记录", active: "record" },
                        { text: "删除", active: "delete" },
                    ]
                    break;

                default:
                    break;
            }
            break
        case "occupation":
            // 职业技能等级考核列表
            switch (status) {
                case "未发布":
                    data = [
                        { text: "发布", active: "issue" },
                        { text: "编辑", active: "edit" },
                        { text: "删除", active: "delete" },
                    ]
                    break;
                case "已发布":
                    data = [
                        { text: "查看", active: "show" },
                        { text: "取消发布", active: "unissue" },
                        { text: "归档", active: "end" },
                    ]
                    break;
                case "已归档":
                    data = [
                        { text: "查看", active: "show" },
                    ]
                    break;

                default:
                    break;
            }
            break
        case "occupationeUser":
            // 查看当前职业技能等级的所有用户
            switch (status) {
                case "合格":
                    data = [
                        { text: "实操成绩录入", active: "entering" }
                    ]
                    break;
                case "不合格":
                    data = [
                        { text: "实操成绩录入", active: "entering" }
                    ]
                    break;

                default:
                    break;
            }
            break
        default:
            break;
    }
    return data
}